/* My Soul Creations — wave edges
   The wave now settles into place as soon as the page paints, rather than waiting
   for a scroll trigger. Waiting made the section boundary look like it was still
   loading for a second or two after the rest of the page was ready. */
(function () {
  function boot() {
    var bands = document.querySelectorAll('[data-msc-tide]');
    if (!bands.length) return;
    bands.forEach(function (b) { b.classList.add('up'); });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();
